import React, { Fragment } from 'react';
import styled from 'styled-components';
import { TextVariant, Typography } from '@components/shared/design/Typography';
import LinkTranslated from '@components/shared/LinkTranslated';
import { getAuthors } from '@components/vitals/data/articleContributors';
import { VITALS_URL } from '@constants';
import { ContentRelationshipFieldPrismic } from '@contracts';

interface NamesRender {
  uid: string;
  name: string;
}

export interface Props {
  people: ContentRelationshipFieldPrismic[];
}

export default function ContributorLinkNames({ people }: Props) {
  const contributors = getAuthors();
  const toRender: NamesRender[] = [];

  people.forEach((person) => {
    const foundC = contributors.find((contributor) => contributor.uid === person.uid);
    if (foundC) {
      const {
        uid,
        data: { name, professional_title }
      } = foundC;

      // TODO Delete once https://app.asana.com/0/home/1207586784179529/1208456938900162 is unblocked
      if (!name || name.length === 0) {
        foundC.data.name = foundC.data.title ?? '';
      }

      const nameToPush = professional_title ? `${name} (${professional_title})` : name;

      if (nameToPush && nameToPush.length > 0) {
        toRender.push({
          uid,
          name: nameToPush
        });
      }
    }
  });

  return toRender.map((item, i, arr) => (
    <Fragment key={item.uid}>
      <LinkTranslated to={`${VITALS_URL}bio/${item.uid}`}>
        <AuthorName $variant={TextVariant.BodyRegularMD}>{item.name}</AuthorName>
      </LinkTranslated>
      {i === arr.length - 1 ? '' : ', '}
    </Fragment>
  ));
}

const AuthorName = styled(Typography)`
  text-transform: capitalize;
  display: inline;
`;
